import { DndProvider } from 'react-dnd';
import HTML5Backend from 'react-dnd-html5-backend';
import React from 'react';
import Box from '@mui/material/Box';
import StatusManagement from './StatusManagement';

const DndProviderComponent = () => {
  return (
    <>
      <Box
        sx={{
          overflow: 'auto',
        }}
      >
        <DndProvider backend={HTML5Backend}>
          <StatusManagement />
        </DndProvider>
      </Box>
    </>
  );
};

export default DndProviderComponent;
